import { z } from 'zod';
import { paginationResponseSchema, createResponseSchema } from '../../../schemas/repository.schemas';
import { companyInfoSchema } from '../../../schemas/company.schemas';

export const companyInfoListResponseSchema = createResponseSchema(
    paginationResponseSchema.extend({
        content: z.array(companyInfoSchema),
    }),
);

export type CompanyInfoListResponseSchemaType = z.infer<typeof companyInfoListResponseSchema>;
